import React from 'react';

import { MenuItem, Popover } from '@mui/material';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { Button } from 'components/Button';

import AddActionModal from 'components/SharedFormComponents/AddTaskModal';

import AddAuditModal from '../AddAuditModal/AddAuditModal';

interface NewActionMenuProps {
  activeTab: 'tasks' | 'audits';
  onRefresh?: () => void;
}

const NewActionMenu: React.FunctionComponent<NewActionMenuProps> = ({ activeTab, onRefresh }): React.ReactElement => {
  const [openModal, setOpenModal] = React.useState(false);

  return (
    <>
      <Button onClick={() => setOpenModal(true)} size="large" variant="contained">
        New
      </Button>
      {openModal && activeTab === 'tasks' && (
        <AddActionModal
          onClose={(created) => {
            setOpenModal(false);
            if (created && onRefresh) {
              onRefresh();
            }
          }}
        />
      )}
      {openModal && activeTab === 'audits' && (
        <AddAuditModal
          onClose={(created) => {
            setOpenModal(false);
            if (created && onRefresh) {
              onRefresh();
            }
          }}
        />
      )}
    </>
  );
};

export default NewActionMenu;
